export default "__VITE_ASSET__DwF2UzTv__"